import React from 'react'

function NoFound() {
  return (
          <div>
        <h1> Sorry Nothing Found!!!!  </h1>         
         </div>
  )
}

export default NoFound;